import "./App.css";
import React, { useRef, useEffect, useState } from "react";
import { WebRTCClient } from "@arcware/webrtc-plugin";
import { Helmet } from "react-helmet";
import AllMaterialPack from "./components/materialPackAll";
import GreyBtn from "./components/greyBtn";
import TotalPrice from "./components/totalPrice";
import CurrentRoom from "./components/currentRoom";
import Teleport from "./components/teleport";
import RoomBook from "./components/roomBook";
import OrderForm from "./components/OrderForm";
import Loading from "./components/loading";
import "./css/normalize.css";
import images from "./assets/images/images";
// import "./css/main.css";

import { isMobile } from "react-device-detect";
import {
	getBasePrice,
	getRoomData,
	getChangeObj,
	// findStartRoom,
} from "./services/dbService";
import axios from "axios";
import { useSearchParams } from "react-router-dom";

import project, { unrealAddress } from "./config";

const projectLogo = require(`./assets/${project.assets}/img/projectLogo.png`);
const flashIcon = require(`./assets/${project.assets}/img/flashIcon.png`);
const doubleTapIcon = require(`./assets/${project.assets}/img/doubleTapIcon.png`);

let isMenuShow = true;
let isMapShow = !isMobile;
let roomId = "01";
let floorId = 1;
let roomIndex = 0;
let isUnrealWakedUp = false;
// let isUnrealOpenMap = false;
let isUEInitialized = false;
let unitName = "";
let isFirefox = typeof InstallTrigger !== "undefined";
let showFireFoxWarn = isFirefox ? "showFirefoxWarn" : "";
let isEmitterInit = false;
let unrealStatus = "starting"; //starting, tryOpenMap, openingMap, ApiFailed
let wakeUpMessageTime = 0;
let ueWakeUpTimeout = 30; //in second
let emitterIntervalID;

let screenDimension = [1920, 1080];
let initializingData = {
	ueInitialized: false,
	apiInitialized: false,
};

localStorage.clear();

function AppUI(props) {
	const { emitUIInteraction } = props;
	const [apiData, setApiData] = useState(null);
	const [changeObj, setChangeObj] = useState(getChangeObj(apiData));
	const [isRoomBookShow, setIsRoomBookShow] = useState(false);
	const [isOrderShow, setIsOrderShow] = useState(false);
	const [searchParams, setSearchParams] = useSearchParams();
	const [isApiFailed, setIsApiFailed] = useState(false);
	const [loadingProcessValue, setLoadingProcessValue] = useState(0);
	const [isUEFailed, setIsUEFailed] = useState(null);
	const [uiFloorId, setUiFloorId] = useState(floorId);

	let apiAddress = project.apiAddress + searchParams.get("key");

	const inputRef = useRef(null);

	//--------------------------- Collapse Menu Part -------------------------
	const [menuClass, setMenuClass] = useState("");
	const [mapClass, setMapClass] = useState(isMobile ? "mapMenuCollapse" : "");
	const [btnClass, setBtnClass] = useState("");
	const [mobileGuideCss, setMobileGuideCss] = useState(
		isMobile ? "mobileGuide" : "hide"
	);

	useEffect(() => {
		//Emitter Interval Initialize
		if (!isEmitterInit) {
			emitterIntervalID = window.setInterval(emitter, 1000);
			isEmitterInit = true;
		}

		async function getDataFromApi(api) {
			try {
				initializingData.apiInitialized = true;
				const data = await axios.get(api);
				setApiData(data);
				setChangeObj(getChangeObj(data));
				unitName = data.data.visualisation.data.unreal_id;
			} catch (ex) {
				unrealStatus = "ApiFailed";
				// console.log(ex);
			}
		}

		getDataFromApi(apiAddress);
	}, []);

	//-------------- Setup Unreal App Resolution Base on client device Resolution -------
	window.addEventListener("resize", setScreenOrientation);

	function setScreenOrientation() {
		let width = window.innerWidth;
		let height = window.innerHeight;
		if (screenDimension[0] !== width && screenDimension[1] !== height) {
			let cmd = "exe-r.SetRes " + width + "x" + height;
			emitUIInteraction(cmd);

			screenDimension[0] = width;
			screenDimension[1] = height;
		}
	}

	setScreenOrientation();

	function emitter() {
		switch (unrealStatus) {
			case "starting":
				if (wakeUpMessageTime < ueWakeUpTimeout) {
					emitUIInteraction("ini-wakeUp-start");

					wakeUpMessageTime += 1;
					// setLoadingProcessValue("Kommunikation starten");
					setLoadingProcessValue((wakeUpMessageTime / ueWakeUpTimeout) * 100);
				} else {
					setIsUEFailed(true);
				}

				break;
			case "openingMap":
				if (wakeUpMessageTime < ueWakeUpTimeout) {
					emitUIInteraction("ini-wakeUp-map");

					wakeUpMessageTime += 1;
					// setLoadingProcessValue("Laden von 3D-Szenen");
					setLoadingProcessValue((wakeUpMessageTime / ueWakeUpTimeout) * 100);
				} else {
					setIsUEFailed(true);
				}

				break;
			case "ApiFailed":
				setIsApiFailed(true);
				break;

			default:
				break;
		}
	}

	const handleKeyDown = (event) => {
		if (event.key === "Enter") {
			emitUIInteraction(inputRef.current.value);
			console.log(inputRef.current.value);
		}
	};

	function findRoomIndex() {
		if (changeObj) {
			// console.log(changeObj.changeObj);
			// for (const key in changeObj) {
			// 	if (changeObj[key].roomId == roomId) {
			// 		// console.log(changeObj[key].roomId);
			// 		return changeObj[key];
			// 	}
			// }
			return changeObj.changeObj.findIndex((f) => f.roomId == roomId);
		}
		return null;
	}

	function updateChanges(choiceObj) {
		let roomIndex = findRoomIndex();
		let newObj = { ...changeObj };

		newObj.changeObj[roomIndex].selectedChoice[choiceObj.id].choice =
			choiceObj.choise;

		setChangeObj(newObj);

		let finalCMD = "mat-" + choiceObj.ueCMD;
		emitUIInteraction(finalCMD);

		console.log(finalCMD);
	}

	function handleMenuCollapse() {
		if (isMenuShow) {
			setMenuClass("mainMenuCollapse");
			setBtnClass("menuBtnCollapse");
			isMenuShow = false;
		} else {
			setMenuClass("");
			setBtnClass("");
			isMenuShow = true;
		}
	}

	function closeMobileGuide() {
		setMobileGuideCss("hide");
	}

	function handleMapCollapse() {
		if (isMapShow) {
			setMapClass("mapMenuCollapse");
			isMapShow = false;
		} else {
			setMapClass("");
			isMapShow = true;
		}
	}

	function handleMovement(ueCMD) {
		let finalCMD = "mov-" + ueCMD;
		emitUIInteraction(finalCMD);
	}

	function handleTeleport(ueCMD) {
		let finalCMD = "tel-" + ueCMD;
		emitUIInteraction(finalCMD);
		// floorId = NewFloorId;
		console.log(finalCMD);
	}

	function handleTeleportFloor(id) {
		floorId = id;
		setUiFloorId(id);
		// console.log(floorId);
	}

	function handleRaumBuch(value) {
		setIsRoomBookShow(value);
	}

	function handleOrder(value) {
		setIsOrderShow(value);
	}

	function handleExit() {
		window.location.href = project.metaURL;
	}

	//------------------------------------------ RENDER SECTION --------------------------------------------------
	if (apiData) {
		roomIndex = findRoomIndex();

		let currentRoomData = getRoomData(roomId, apiData);

		return (
			<React.Fragment>
				<Helmet>
					<title>{project.metaTitle}</title>
					<meta name="description" content={project.metaDescription} />

					<meta property="og:url" content={project.metaURL} />
					<meta property="og:type" content="website" />
					<meta property="og:title" content={project.metaTitle} />
					<meta property="og:description" content={project.metaDescription} />
					<meta property="og:image" content={project.metaImage} />

					<meta name="twitter:card" content="summary_large_image" />
					<meta property="twitter:domain" content={project.metaDomain} />
					<meta property="twitter:url" content={project.metaURL} />
					<meta name="twitter:title" content={project.metaTitle} />
					<meta name="twitter:description" content={project.metaDescription} />
					<meta name="twitter:image" content={project.metaImage} />

					<link rel="icon" href={project.icon32} sizes="32x32" />
					<link rel="apple-touch-icon" href={project.appleTouchIcon} />

					<script
						async
						src={
							"https://www.googletagmanager.com/gtag/js?id=" +
							project.googleTrackingID
						}
					></script>
					<script>
						{`window.dataLayer = window.dataLayer || []; ` +
							`function gtag(){dataLayer.push(arguments);} ` +
							`gtag('js', new Date()); ` +
							`gtag('config', '${project.googleTrackingID}');`}
					</script>
				</Helmet>

				<Loading
					initializingData={initializingData}
					isUEFailed={isUEFailed}
					isApiFailed={isApiFailed}
					unrealStatus={unrealStatus}
					loadingProcessValue={loadingProcessValue}
				/>
				<div className={"fireFoxWarn " + showFireFoxWarn}>
					<span>
						Bitte verwenden Sie einen anderen Browser, da Firefox derzeit nicht
						unterstützt wird.
					</span>
					<a href={project.metaURL}>Zurück zur Website</a>
				</div>
				<div className={mobileGuideCss}>
					<div onClick={closeMobileGuide}>X</div>
					<img src={doubleTapIcon} alt="doppelt tippen" />
					<span>Um vorwärts zu gehen, bitte doppelt tippen</span>
				</div>
				<section className="homeKlickContainer">
					<span>Powered by:</span>
					<a href="https://home-klick.de/" target={"_blank"}>
						<img src={images.homeKlickLogo} />
					</a>
				</section>
				<div className={"rightColumn " + menuClass}>
					{/* <button onClick={handleMenuCollapse} className={"menuBtn " + btnClass}> */}
					<button onClick={handleMenuCollapse} className="menuBtn">
						<img src={flashIcon} alt="" />
					</button>
					{/* <div className={"mainMenu " + menuClass}> */}
					<div className={"mainMenu "}>
						<div className="menuUpper">
							<div className="menuProjectLogo">
								<img src={projectLogo} alt="" />
							</div>
							<div className="menuBtnRow">
								{/* <GreyBtn key="1" cssClass={"btnInfo"} name={"Anleitung"} /> */}
								{/* <GreyBtn key="2" cssClass={"btnProfile"} name={"Profil"} /> */}
								<GreyBtn
									key="3"
									cssClass={"btnBack"}
									name={"Beenden"}
									btnClick={() => handleExit()}
								/>
							</div>
						</div>
						<div className="matListContainer">
							<CurrentRoom roomData={currentRoomData} changeObj={changeObj} />

							<AllMaterialPack
								roomId={roomId}
								roomIndex={roomIndex}
								changeObj={changeObj}
								roomData={currentRoomData}
								handleUEcmd={updateChanges}
							/>
						</div>
						<div className="menuBottom">
							<div className="menuBtnRow">
								<GreyBtn
									key="4"
									cssClass={"btnBook"}
									name={"Raumbuch"}
									btnClick={() => handleRaumBuch(true)}
								/>
								{/* <GreyBtn
									key="5"
									cssClass={"btnOrder"}
									name={"Anfrage"}
									btnClick={() => handleOrder(true)}
								/> */}
								{/* <GreyBtn key="5" cssClass={"btnLaden"} name={"Laden"} /> */}
								{/* <GreyBtn key="6" cssClass={"btnSave"} name={"Speichern"} /> */}
							</div>
							<TotalPrice
								basePrice={getBasePrice(apiData)}
								changeObj={changeObj}
							/>
							{/* <input
								style={{
									position: "fixed",
									left: "50%",
									top: "50%",
									zIndex: "9999",
								}}
								ref={inputRef}
								onKeyDown={handleKeyDown}
							/> */}
						</div>
					</div>
				</div>
				<Teleport
					onShowHide={handleMapCollapse}
					mapClass={mapClass}
					apiData={apiData}
					currentData={[roomId, floorId]}
					pointClick={handleTeleport}
					floorClick={handleTeleportFloor}
				/>
				<RoomBook
					apiData={changeObj}
					basePrice={getBasePrice(apiData)}
					isShow={isRoomBookShow}
					setHide={handleRaumBuch}
				/>
				<OrderForm
					apiData={changeObj}
					basePrice={getBasePrice(apiData)}
					isShow={isOrderShow}
					setHide={handleOrder}
				/>
				<div className="discaimer">Abbildung kann vom Original abweichen</div>
				{/* <div className="controllerContainer">
					<button
						className="moveUp"
						onMouseUp={() => handleMovement("ForwardUp")}
						onMouseDown={() => handleMovement("ForwardDown")}
						onTouchStartCapture={() => handleMovement("ForwardDown")}
						onTouchEndCapture={() => handleMovement("ForwardUp")}
					></button>
					<button
						className="moveLeft"
						onMouseUp={() => handleMovement("LeftUp")}
						onMouseDown={() => handleMovement("LeftDown")}
						onTouchStartCapture={() => handleMovement("LeftDown")}
						onTouchEndCapture={() => handleMovement("LeftUp")}
					></button>
					<button
						className="moveRight"
						onMouseUp={() => handleMovement("RightUp")}
						onMouseDown={() => handleMovement("RightDown")}
						onTouchStartCapture={() => handleMovement("RightDown")}
						onTouchEndCapture={() => handleMovement("RightUp")}
					></button>
					<button
						className="moveDown"
						onMouseUp={() => handleMovement("BackUp")}
						onMouseDown={() => handleMovement("BackDown")}
						onTouchStartCapture={() => handleMovement("BackDown")}
						onTouchEndCapture={() => handleMovement("BackUp")}
					></button>
				</div> */}
			</React.Fragment>
		);
	} else {
		return (
			<Loading
				initializingData={initializingData}
				isUEFailed={isUEFailed}
				isApiFailed={isApiFailed}
				unrealStatus={unrealStatus}
				loadingProcessValue={loadingProcessValue}
			/>
		);
	}
}

function whichMap(emitUIInteraction) {
	if (unrealStatus == "starting" && unitName !== "") {
		let newMap = "ini-map-" + unitName;
		emitUIInteraction(newMap);
		unrealStatus = "tryOpenMap";
		// console.log(newMap);
	}
}

function whichDevice(emitUIInteraction) {
	// if (!isUEInitialized) {
	if (isMobile) {
		// console.log("IS MOBILE");
		emitUIInteraction("ini-device-mobile");
	} else {
		// console.log("IS PC");
		emitUIInteraction("ini-device-pc");
	}
	// isUEInitialized = true;
	// }
}

function initialized(emitUIInteraction) {
	if (!isUEInitialized) {
		initializingData.ueInitialized = true;
		// roomId = 1;

		let width = window.innerWidth;
		let height = window.innerHeight;
		let cmd = "exe-r.SetRes " + width + "x" + height;
		emitUIInteraction(cmd);
		clearInterval(emitterIntervalID);
		isUEInitialized = true;
	}
}

function Responses(props) {
	const { responses, emitUIInteraction } = props;
	// console.log("Unreal message:  ", responses);
	// let newRoomId = -1;

	if (responses[0] !== "" && responses[0]) {
		let commands = responses[0].split("-");
		// let commands = responses;
		for (const iterator of commands) {
			switch (iterator) {
				case "Nowhere":
					roomId = 0;
					break;
				case "Pid,01":
					roomId = 1;
					break;
				case "Pid,02":
					roomId = 2;
					break;
				case "Pid,03":
					roomId = 3;
					break;
				case "Pid,04":
					roomId = 4;
					break;
				case "Pid,05":
					roomId = 5;
					break;
				case "Pid,06":
					roomId = 6;
					break;
				case "Pid,07":
					roomId = 7;
					break;
				case "Pid,08":
					roomId = 8;
					break;
				case "Pid,09":
					roomId = 9;
					break;
				case "Pid,10":
					roomId = 10;
					break;
				case "Fid,01":
					floorId = 1;
					break;
				case "Fid,02":
					floorId = 2;
					break;
				case "Fid,03":
					floorId = 3;
					break;
				case "Fid,04":
					floorId = 4;
					break;
				case "Fid,05":
					floorId = 5;
					break;
				case "whichMap":
					whichMap(emitUIInteraction.emitUIInteraction);
					break;
				case "openingMap":
					wakeUpMessageTime = 0;
					unrealStatus = "openingMap";
					break;
				case "mapOpened":
					unrealStatus = "mapOpened";
					whichDevice(emitUIInteraction.emitUIInteraction);
					break;
				// case "whichDevice":
				// 	whichDevice(emitUIInteraction.emitUIInteraction);
				// 	break;
				case "Initialized":
					initialized(emitUIInteraction.emitUIInteraction);
					break;
			}
		}
		// console.log("FloorID: ", floorId, "  -- PlaceID: ", roomId);
	}

	return (
		<div className="responses-block">
			{/* <h4>Response log from UE app:</h4>
			<div className="responses-list">
				{responses.map((v) => (
					<p>{v}</p>
				))}
			</div> */}
		</div>
	);
}

function App() {
	const sizeContainerRef = useRef(null);
	const containerRef = useRef(null);
	const videoRef = useRef(null);
	const [webrtcClient, setWebrtcClient] = useState();
	const [responses, setResponses] = useState([]);
	let webrtcClientInit = false;

	const responseCallback = (message) => {
		setResponses([message, ...responses]);
	};

	const videoInitialized = () => {
		if (webrtcClient) {
			// webrtcClient.emitUIInteraction(descriptors.color.black);
		}
	};

	useEffect(() => {
		const args = {
			address: unrealAddress,
			// packageId: "154ff849-f787-4f37-b479-76253341b0ea", Pestalozzi
			// packageId: "093b3650-6bc1-471f-945d-5af202e8313a", Amsel
			// packageId: "abfb6428-16a1-468c-89e4-47af805c92f1",
			packageId: project.packageId,
			settings: {},
			sizeContainer: sizeContainerRef.current,
			container: containerRef.current,
			videoRef: videoRef.current,
			playOverlay: false,
			loader: () => {},
			applicationResponse: responseCallback,
			videoInitializeCallback: videoInitialized,
		};

		// double load protection
		if (!webrtcClientInit) {
			webrtcClientInit = true;
			setWebrtcClient(new WebRTCClient(args));
		}
	}, []);

	useEffect(() => {}, []);

	return (
		<div className="App">
			<div ref={sizeContainerRef}>
				<div ref={containerRef} style={{ zIndex: 1 }}>
					<video ref={videoRef} />
					<Responses responses={responses} emitUIInteraction={webrtcClient} />
					{webrtcClient != null && (
						<AppUI emitUIInteraction={webrtcClient.emitUIInteraction} />
					)}
				</div>
			</div>
		</div>
	);
}

export default App;
